import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { usePlatformStore } from "@platform/store";
import { useFetchActions, groupActionsByOrganization } from "@core/features/actions";
import { OrgAdminActionsSection } from "./OrgAdminActionsSection";

export function OrgAdminActionsSectionContainer() {
  const { id } = useParams<{ id: string }>();
  const programId = id ? Number(id) : undefined;
  const user = usePlatformStore((s) => s.user);

  const { data: actionsData } = useFetchActions({
    programId,
    user,
    isEnabled: !!user,
  });

  const organizationActionGroups = useMemo(
    () => groupActionsByOrganization(actionsData?.actions ?? []),
    [actionsData?.actions]
  );

  return (
    <OrgAdminActionsSection organizationActionGroups={organizationActionGroups} />
  );
}

export default OrgAdminActionsSectionContainer;
